var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',[_c('div',{staticClass:"order-empty"},[_c('div',{staticClass:"order-empty__text"},[_vm._v("У вас в корзине нет товара!")]),_c('div',[_c('FormButton',{on:{"click":function($event){return _vm.$router.push({ name: 'home' })}}},[_vm._v(" К витрине ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }